import { createReducer } from '../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../utils/ActionStatus';
import UrlConfig from '../../../net/UrlConfig';

import {
  ON_CPT_QUERY_INPUT_CHANGE,
  START_LOAD_CPT_INFO,
  LOAD_CPT_INFO_SUCCESS,
  LOAD_CPT_INFO_FAILURE,
  INIT_LOAD_CPT_INFO_ACTION_STATUS,
  SELECT_CPT_INFO,
  OPEN_ADD_OR_EDIT_CPT_MODAL,
  ADD_OR_EDIT_CPT_CHANGE_INPUT,
  START_ADD_OR_EDIT_CPT,
  ADD_OR_EDIT_CPT_SUCCESS,
  ADD_OR_EDIT_CPT_FAILURE,
  INIT_ADD_OR_EDIT_CPT_ACTION_STATUS,
  RESET_ADD_OR_EDIT_CPT_MODAL,
  OPEN_DEL_CPT_MODAL,
  START_DEL_CPT,
  DEL_CPT_SUCCESS,
  DEL_CPT_FAILURE,
  INIT_DEL_CPT_ACTION_STATUS,
  RESET_DEL_CPT_MODAL,
  START_SUBMIT_CPT,
  SUBMIT_CPT_SUCCESS,
  SUBMIT_CPT_FAILURE,
  INIT_SUBMIT_CPT_ACTION_STATUS,
} from './CptConstants';

const initialCptFields = {
  id: null,
  employee: '',
  eventDate: '',
  eventOrganizer: '',
  eventName: '',
  cptCategory: '',
  cptHours: '',
  attachment: '',
  attachmentOriginName: '',
  remarks: '',
  complianceApproval: '',
  fileList: [],
};

const initialState = {
  cptOperationRecordUrl: UrlConfig.QUERY_CPT_OPERATION_RECORD,
  cptQueryFields: {
    year: '',
  },
  loadCptInfoActionStatus: ACTION_STATUS.READY,
  loadCptInfoResp: null,
  selectedCptInfoArray: [],
  addOrEditCptModal: {
    isOpened: false,
    mode: 'ADD',
    respErrMsg: '',
    fields: initialCptFields,
  },
  addOrEditCptActionStatus: ACTION_STATUS.READY,
  delCptModal: {
    isOpened: false,
    respErrMsg: '',
    fields: {
      id: null,
    },
  },
  delCptActionStatus: ACTION_STATUS.READY,
  submitCptActionStatus: ACTION_STATUS.READY,
  submitCptRespErrMsg: '',
};

function onCptQueryInputChange(state, { name, value }) {
  return {
    ...state,
    cptQueryFields: {
      ...state.cptQueryFields,
      [name]: value,
    },
  };
}

function startLoadCptInfo(state) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.LOGINING,
  };
}

function loadCptInfoSuccess(state, resp) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.SUCCESS,
    loadCptInfoResp: resp,
  };
}

function loadCptInfoFailure(state, err) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.ERROR,
    loadCptInfoResp: err,
  };
}

function initLoadCptInfoActionStatus(state) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.READY,
    selectedCptInfoArray: [],
  };
}

function selectCptInfo(state, array) {
  return {
    ...state,
    selectedCptInfoArray: array,
  };
}

function openAddOrEditCptModal(state, { mode, data }) {
  if (mode === 'ADD' || !data) {
    return {
      ...state,
      addOrEditCptModal: {
        ...state.addOrEditCptModal,
        isOpened: true,
        mode,
        respErrMsg: '',
        fields: { ...initialCptFields, fileList: [] },
      },
    };
  }

  const isCopy = mode === 'COPY';
  return {
    ...state,
    addOrEditCptModal: {
      ...state.addOrEditCptModal,
      isOpened: true,
      mode,
      respErrMsg: '',
      fields: {
        id: isCopy ? null : data.id,
        employee: data.employee || '',
        eventDate: data.eventDate || '',
        eventOrganizer: data.eventOrganizer || '',
        eventName: data.eventName || '',
        cptCategory: data.cptCategory || '',
        cptHours: data.cptHours || '',
        attachment: data.attachment || '',
        attachmentOriginName: data.attachmentOriginName || '',
        remarks: data.remarks || '',
        complianceApproval: isCopy ? '' : (data.complianceApproval || ''),
        fileList: data.attachment ? [{
          uid: '-1',
          name: data.attachmentOriginName || data.attachment,
          status: 'done',
          url: data.attachment,
        }] : [],
      },
    },
  };
}

function addOrEditCptChangeInput(state, { name, value }) {
  return {
    ...state,
    addOrEditCptModal: {
      ...state.addOrEditCptModal,
      fields: {
        ...state.addOrEditCptModal.fields,
        [name]: value,
      },
    },
  };
}

function startAddOrEditCpt(state) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.LOGINING,
  };
}

function addOrEditCptSuccess(state) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function addOrEditCptFailure(state, err) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.ERROR,
    addOrEditCptModal: {
      ...state.addOrEditCptModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initAddOrEditCptActionStatus(state) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.READY,
  };
}

function resetAddOrEditCptModal(state) {
  return {
    ...state,
    addOrEditCptModal: {
      ...initialState.addOrEditCptModal,
      fields: { ...initialCptFields, fileList: [] },
    },
  };
}

function openDelCptModal(state, data) {
  return {
    ...state,
    delCptModal: {
      ...state.delCptModal,
      isOpened: true,
      respErrMsg: '',
      fields: {
        id: data.id,
      },
    },
  };
}

function startDelCpt(state) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.LOGINING,
  };
}

function delCptSuccess(state) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function delCptFailure(state, err) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.ERROR,
    delCptModal: {
      ...state.delCptModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initDelCptActionStatus(state) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.READY,
  };
}

function resetDelCptModal(state) {
  return {
    ...state,
    delCptModal: initialState.delCptModal,
  };
}

function startSubmitCpt(state) {
  return {
    ...state,
    submitCptActionStatus: ACTION_STATUS.LOGINING,
    submitCptRespErrMsg: '',
  };
}

function submitCptSuccess(state) {
  return {
    ...state,
    submitCptActionStatus: ACTION_STATUS.SUCCESS,
    submitCptRespErrMsg: '',
  };
}

function submitCptFailure(state, err) {
  return {
    ...state,
    submitCptActionStatus: ACTION_STATUS.ERROR,
    submitCptRespErrMsg: err && err.respMessage ? err.respMessage : '',
  };
}

function initSubmitCptActionStatus(state) {
  return {
    ...state,
    submitCptActionStatus: ACTION_STATUS.READY,
    submitCptRespErrMsg: '',
  };
}

export default createReducer(initialState, {
  [ON_CPT_QUERY_INPUT_CHANGE]: onCptQueryInputChange,
  [START_LOAD_CPT_INFO]: startLoadCptInfo,
  [LOAD_CPT_INFO_SUCCESS]: loadCptInfoSuccess,
  [LOAD_CPT_INFO_FAILURE]: loadCptInfoFailure,
  [INIT_LOAD_CPT_INFO_ACTION_STATUS]: initLoadCptInfoActionStatus,
  [SELECT_CPT_INFO]: selectCptInfo,
  [OPEN_ADD_OR_EDIT_CPT_MODAL]: openAddOrEditCptModal,
  [ADD_OR_EDIT_CPT_CHANGE_INPUT]: addOrEditCptChangeInput,
  [START_ADD_OR_EDIT_CPT]: startAddOrEditCpt,
  [ADD_OR_EDIT_CPT_SUCCESS]: addOrEditCptSuccess,
  [ADD_OR_EDIT_CPT_FAILURE]: addOrEditCptFailure,
  [INIT_ADD_OR_EDIT_CPT_ACTION_STATUS]: initAddOrEditCptActionStatus,
  [RESET_ADD_OR_EDIT_CPT_MODAL]: resetAddOrEditCptModal,
  [OPEN_DEL_CPT_MODAL]: openDelCptModal,
  [START_DEL_CPT]: startDelCpt,
  [DEL_CPT_SUCCESS]: delCptSuccess,
  [DEL_CPT_FAILURE]: delCptFailure,
  [INIT_DEL_CPT_ACTION_STATUS]: initDelCptActionStatus,
  [RESET_DEL_CPT_MODAL]: resetDelCptModal,
  [START_SUBMIT_CPT]: startSubmitCpt,
  [SUBMIT_CPT_SUCCESS]: submitCptSuccess,
  [SUBMIT_CPT_FAILURE]: submitCptFailure,
  [INIT_SUBMIT_CPT_ACTION_STATUS]: initSubmitCptActionStatus,
});
